import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux"
import makeStyles from '@material-ui/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import { DialogPortifolio } from '../DialogPortifolio';
import { portfolioDialogTaskActions } from "../../../actions/portfolio/portfolio-dialog-task.actions"

const useStyles = makeStyles((theme) => ({
  titleDelete: {
    fontSize: 20,
    fontWeight: 600,
    paddingBottom: 15,
    color: theme.palette.neutrals.low.dark
  },
  descriptionDelete: {
    fontSize: 16,
    color: theme.palette.neutrals.low.medium
  },
  btnFloat: {
    float: 'right',
  },
}));

export function DialogConfirmDeleteTask({ open, onClose, subtaskIndex }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { loading, success } = useSelector(state => state.portfolioDialogProject);
  const { t } = useTranslation();

  useEffect(() => {
    if (success) {
      handleClose()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]) 

  function handleClose() {
    onClose()
  }

  function handleDeleteSubtask() {
    handleClose();
    dispatch(portfolioDialogTaskActions.removeSubtask(subtaskIndex))
  }

  return (
    <DialogPortifolio
      title={t('deletar_subtarefa')}
      open={open}
      onClose={onClose}
      content={
        <Grid item xs={12}>
          <Typography className={classes.descriptionDelete}>
            {t('as_informacoes_de_status_serao_perdidas.')}
          </Typography>
        </Grid>
      }
      action={
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              type="submit"
              color="primary"
              variant="outlined"
              onClick={handleClose}
              disabled={loading}
            >
              {t('voltar')}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.btnFloat}
              startIcon={<DeleteIcon />}
              onClick={handleDeleteSubtask}
              disabled={loading}
            >
              {t('confirmar')}
            </Button>
          </Grid>
        </Grid>
      }
    />
  );
}